import { createAction, props } from '@ngrx/store';

export const showError = createAction('[TaskMgmt.Error] Show Error', props<{ payload?: string }>());
export const resetError = createAction('[TaskMgmt.Error] Reset Error');
